// @ts-nocheck

import React, { useMemo } from 'react';
import styled from 'styled-components';

import LineUpOpenViewButtonContainer from '../../modules/line-up/components/LineUpOpenViewButton/LineUpOpenViewButtonContainer';
import theme from '../../styled-components/dark';
import { BetGroupLabel, BetGroupWrapper } from '../../styled-components/shared';
import type { BetGroupOutcome } from '../../types/betGroup';
import BetGroupOutcomeContainer from '../BetGroupOutcome/BetGroupOutcomeContainer';
import FlagIcon from '../FlagIcon';

const Wrap = styled.div`
  margin: 0.6em;
`;

const Separator = styled.div`
  height: 1px;
  width: 80%;
  margin-left: 10%;
  background-color: ${theme.MatchBetGroup.separatorColor};
  margin-bottom: 1.5em;
`;

const StyledBetGroupOutcomeContainer = styled(BetGroupOutcomeContainer)`
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin: 0.6em 0;

  &:first-child {
    margin-top: 0;
  }

  &:last-child {
    margin-bottom: 0;
  }

  .bet-group-outcome-title {
    width: 100%;
    text-align: left;
  }
  .bet-group-outcome-odd {
    width: calc(50% - 0.4em);
  }
`;

const FlagLabelWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const StyledFlagIcon = styled(FlagIcon)`
  width: 1.4em;
  height: 1.4em;
  border-radius: 0.3em;
  margin-right: 0.6em;
`;

const StyledGroupLabel = styled(BetGroupLabel)`
  margin: 0.6em 0;
`;

const StyledLineUpOpenViewButtonContainer = styled(LineUpOpenViewButtonContainer)`
  margin-right: 0;

  &:only-child {
    margin-left: auto;
  }
`;

type BetGroupListProps = {
  className?: string;
  groupLabel: string | null;
  items: Array<BetGroupOutcome>;
  showPercentDistribution: boolean;
  betIsAvailable: boolean;
  betTemplate: string;
  teamId?: number;
  matchId: number;
  flag?: string;
  hasStarters: boolean;
  isMultichoice?: boolean;
  showLineUpButton?: boolean;
};

const BetGroupList = ({
  className,
  groupLabel,
  items = [],
  showPercentDistribution,
  betTemplate,
  teamId,
  matchId,
  flag,
  hasStarters,
  isMultichoice = false,
  showLineUpButton = false,
}: BetGroupListProps) => {
  const finalItems = useMemo(() => {
    let previousBetId = null;
    const res = [];

    for (let i = 0; i < items.length; i++) {
      const { matchId, betId, id, playerTrackerInfos, starter, disableDivider } = items[i] ?? {};

      if (previousBetId && previousBetId !== betId && !disableDivider) {
        res.push(<Separator key={`separator-${res.length}`} />);
      }
      res.push(
        <StyledBetGroupOutcomeContainer
          key={`betgroup-${matchId ?? ''}-${betId ?? ''}-${id ?? ''}-${i}`}
          matchId={matchId}
          betId={betId}
          oddId={id}
          betTemplate={betTemplate}
          showPercentDistribution={showPercentDistribution}
          playerTrackerInfos={playerTrackerInfos}
          starter={starter}
          showStarterLabel={hasStarters}
        />,
      );
      previousBetId = betId;
    }
    return res;
  }, [betTemplate, items, showPercentDistribution, hasStarters]);
  const defaultMarketId = useMemo(() => items[0].marketId, [items]);
  const defaultSBV = useMemo(() => items[0].specialBetValue, [items]);

  return (
    <Wrap className={className}>
      {groupLabel || showLineUpButton ? (
        <BetGroupWrapper>
          <FlagLabelWrapper>
            {flag ? <StyledFlagIcon flagId={flag} /> : null}
            {groupLabel ? <StyledGroupLabel>{groupLabel}</StyledGroupLabel> : null}
          </FlagLabelWrapper>
          {showLineUpButton ? (
            <StyledLineUpOpenViewButtonContainer
              teamId={teamId}
              marketId={defaultMarketId}
              specialBetValue={defaultSBV}
              matchId={matchId}
              isFromMultichoice={isMultichoice}
            />
          ) : null}
        </BetGroupWrapper>
      ) : null}
      {finalItems}
    </Wrap>
  );
};

export default BetGroupList;
